@if (isConfigurazione) {
  <div class="cnt-bottoni">
    <mat-form-field (mousedown)="$event.stopPropagation()" class="titolo-tabella">
      <mat-label>Titolo Tabella</mat-label>
      <textarea
        #inputDesc
        matInput
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="1"
        [(ngModel)]="titoloTabella"
        rows="1"
      ></textarea>
      <mat-error appFormError></mat-error>
    </mat-form-field>

    <div class="cnt-slider-info">
      <div class="cnt-slider">
        <mat-slide-toggle [(ngModel)]="totaleColonne" [disabled]="disabilitaTotali()">
          Totale Colonne
        </mat-slide-toggle>
        <mat-slide-toggle [(ngModel)]="totaleRighe" [disabled]="disabilitaTotali()"
          >Totale Righe
        </mat-slide-toggle>
      </div>
      <div style="display: flex; align-items: center; padding-top: 4px">
        <mat-icon
          matTooltip="Se abilitati, nella stampa della tabella verrà mostrata una riga o colonna dei totali. Per attivare questa funzione, è necessario inserire almeno una colonna con un'unità di misura."
          style="color: grey; transform: scale(0.8)"
        >
          info_outline
        </mat-icon>
      </div>
    </div>
    <button
      mat-raised-button
      color="accent"
      appFormElement
      [larghezza]="1"
      class="accent-button"
      (click)="aggiungiColonna()"
    >
      <mat-icon style="transform: scale(1.3)">add</mat-icon> Colonna
    </button>

    <button
      mat-raised-button
      color="accent"
      class="accent-button"
      appFormElement
      [larghezza]="1"
      [disabled]="!colonne.length"
      (click)="aggiungiRiga()"
    >
      <mat-icon style="transform: scale(1.3)">add</mat-icon> Riga
    </button>
  </div>
}

@if (!colonne.length) {
  <div class="no-data">Inserire almeno una colonna</div>
} @else {
  <div class="table-wrapper">
    <table mat-table [dataSource]="righe" class="styled-table mat-elevation-z2">
      <!-- TASTO DI ELIMINAZIONE RIGA SE SONO IN COMPILAZIONE -->
      @if (nascondiPrimaColonna() && !isConfigurazione && this.mostraELimina) {
        <ng-container matColumnDef="azione">
          <th mat-header-cell *matHeaderCellDef class="col-header-cell" style="border: none"></th>

          <td mat-cell *matCellDef="let riga; let i = index" style="border: none">
            <button
              mat-icon-button
              color="warn"
              (click)="rimuoviRiga(riga); this.onModificaTabella(this.salva())"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>
      }

      <!-- Header RIGHE dinamiche-->
      <ng-container matColumnDef="rowLabel">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="row-header-cell"
          [class.solo-colonne]="nascondiPrimaColonna()"
        ></th>

        <td
          mat-cell
          *matCellDef="let riga; let i = index"
          class="row-header-cell"
          [class.solo-colonne]="nascondiPrimaColonna()"
        >
          <mat-form-field appearance="fill" class="mat-input-table" subscriptSizing="dynamic">
            <textarea
              matInput
              #rowTextareaEl
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              [disabled]="disabilitaHeaderRC"
              [readonly]="!isConfigurazione"
              placeholder="Descrivi riga"
              class="custom-textarea"
              [(ngModel)]="riga.label"
              (click)="modificaHeader('RIGA', riga)"
              [attr.data-riga-id]="riga.id"
              rows="1"
              [required]="isRequired() && !riga.label"
              [appForceErrorView]="isRequired()"
            ></textarea>
          </mat-form-field>
        </td>
      </ng-container>

      <!-- HEADER Colonne dinamiche -->
      <ng-container *ngFor="let col of colonne; let i = index" [matColumnDef]="col.id">
        <!-- Header -->
        <th mat-header-cell *matHeaderCellDef class="col-header-cell">
          <mat-form-field appearance="fill" class="mat-input-table" subscriptSizing="dynamic">
            <textarea
              matInput
              #colTextareaEl
              cdkAutosizeMinRows="1"
              placeholder="Descrivi colonna"
              [readonly]="!isConfigurazione"
              [disabled]="disabilitaHeaderRC"
              class="custom-textarea"
              (click)="modificaHeader('COLONNA', col)"
              [(ngModel)]="col.label"
              [attr.data-col-id]="col.id"
              (input)="sincronizzaAltezzaColonna()"
              (blur)="this.onModificaTabella(this.salva())"
              rows="1"
              [required]="isRequired() && !col.label"
              [appForceErrorView]="isRequired()"
            ></textarea>

            @if (col.tipoColonna === 'UM') {
              <span
                matTextSuffix
                style="font-size: 12px"
                [matTooltip]="col.unitaDiMisura?.descrizione"
                >{{ col.unitaDiMisura?.nomeBreve }} &nbsp;</span
              >
            }
          </mat-form-field>
        </th>

        <!-- Cella riga colonna (matrice) -->
        <td mat-cell *matCellDef="let riga">
          @if (!isConfigurazione) {
            @if (col.tipoColonna === 'BOOLEAN') {
              <div
                class="bool-toggle"
                [class.is-disabled]="disabilitaCelle"
                [class.has-error]="isRequired() && !riga.celle[riga.id][col.id]"
              >
                <button
                  type="button"
                  class="bool-toggle__btn bool-toggle__btn--si"
                  [class.bool-toggle__btn--active]="riga.celle[riga.id][col.id] === 'SI'"
                  [disabled]="disabilitaCelle"
                  (click)="
                    !disabilitaCelle && (riga.celle[riga.id][col.id] = 'SI');
                    onModificaTabella(salva())
                  "
                >
                  SÌ
                </button>
                <div class="border-bool-btn"></div>
                <button
                  type="button"
                  class="bool-toggle__btn bool-toggle__btn--no"
                  [class.bool-toggle__btn--active]="riga.celle[riga.id][col.id] === 'NO'"
                  [disabled]="disabilitaCelle"
                  (click)="
                    !disabilitaCelle && (riga.celle[riga.id][col.id] = 'NO');
                    onModificaTabella(salva())
                  "
                >
                  NO
                </button>
              </div>
            } @else {
              <mat-form-field
                appearance="fill"
                class="mat-input-table input-celle"
                subscriptSizing="dynamic"
              >
                <textarea
                  matInput
                  #rowTextareaEl
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="1"
                  class="custom-textarea"
                  [placeholder]="col.tipoColonna === 'UM' ? 'Valore' : 'Descrivi'"
                  [(ngModel)]="riga.celle[riga.id][col.id]"
                  [disabled]="disabilitaCelle"
                  (input)="sincronizzaAltezzaRiga(riga.id); onInput($event, col, riga)"
                  (blur)="this.onModificaTabella(this.salva())"
                  [attr.data-riga-id]="riga.id"
                  rows="1"
                  [required]="isRequired() && !riga.celle[riga.id][col.id]"
                  [appForceErrorView]="isRequired()"
                ></textarea>
              </mat-form-field>
            }
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  @if (nascondiPrimaColonna() && !nascondiBottoni && !isConfigurazione) {
    <div class="btn-compilazione">
      <button
        mat-stroked-button
        class="bottoni-risposte"
        (click)="aggiungiRiga(); this.onModificaTabella(this.salva())"
      >
        <mat-icon class="material-icons-outlined"> add</mat-icon> Aggiungi Riga Tabella
      </button>
      <button mat-stroked-button class="bottoni-risposte" (click)="mostraElimina(!mostraELimina)">
        <mat-icon class="material-icons" color="warn"> delete</mat-icon>
        {{ mostraELimina ? 'Nascondi Cestino Righe' : 'Gestione Rimozione Righe' }}
      </button>
    </div>
  }
}
